import script from "./ListMessages.vue?vue&type=script&setup=true&lang=js"
export * from "./ListMessages.vue?vue&type=script&setup=true&lang=js"

import "./ListMessages.vue?vue&type=style&index=0&id=6a599d4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a599d4e"]])

export default __exports__